/* Icon.tsx
   Version: 1.1.0
   Date: 2020-12-16
*/

// eslint-disable-next-line
import React from 'react';
import PropTypes from 'prop-types';

export interface IconProps {
    className: string
    url: string;
    name?: string;
    index?: number;
    onClick?: (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => void;
}

const Icon: React.FC<IconProps> = (props): JSX.Element => {

    Icon.propTypes = {
        className: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        name: PropTypes.string,
        index: PropTypes.number,
        onClick: PropTypes.func,
    }

    return (
        <img className={props.className} src={props.url} alt='icon' data-name={props.name} data-index={props.index} onClick={props.onClick} />
    )

}

export default Icon;